import { Grid } from '@mui/material'

import useStyles from './index.styles'

const SubmitContainer = ({ children }: React.PropsWithChildren) => {
  const classes = useStyles

  return (
    <Grid container={true} size={12} sx={classes.container}>
      {children}
    </Grid>
  )
}

export default SubmitContainer
